import Head from 'next/head';
import { GetStaticPaths, GetStaticProps } from 'next';
import marked from 'marked';
import { useRouter } from 'next/router';
import {
  getAllResources,
  getSingleResource,
  Resource,
} from ':src/utils/getResources';

export type ResourcePageProps = {
  resource: Resource;
};

export const getStaticProps: GetStaticProps<
  ResourcePageProps,
  { slug: string }
> = async ({ params }) => {
  const { slug } = params!;
  const resource = await getSingleResource(slug);
  return {
    props: { resource },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: (await getAllResources()).map((resource) => ({
      params: {
        slug: resource.slug,
      },
    })),
    fallback: 'blocking',
  };
};

export default function ResourcePage({ resource }: ResourcePageProps) {
  const router = useRouter();
  const { title, description } = resource;
  const pageURL = `${process.env.DOMAIN!}${router.asPath}`;
  return (
    <>
      <Head>
        <title>{title} | frontendeval</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={pageURL} />
        <meta
          property="og:image"
          content={`${process.env.DOMAIN!}/brand/icon.png`}
        />
      </Head>
      <div className="container">
        <div className="prose my-8 mx-auto">
          <h1>{title}</h1>
          {/* eslint-disable react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: marked(resource.body) }} />
          {/* eslint-enable react/no-danger */}
        </div>
      </div>
    </>
  );
}
